import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Flex,
  Box,
  Table,
  Thead,
  Tbody,
  Text,
  Tr,
  Th,
  TableCaption,
  TableContainer,
  ModalFooter,
  Spinner,
  Stack,
  RadioGroup,
  Radio,
  useToast,
  Spacer
} from '@chakra-ui/react'
import { FC, useCallback, useEffect, useState } from 'react'
import { BiSliderAlt } from 'react-icons/bi'
import { useImmer } from 'use-immer'

import budget from '@service/filters'
const BudgetParameterModalConfig: FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [rows, updateRows] = useImmer<any[]>([])
  const [rowsUpdate, updateDataMargeUpdate] = useImmer<any[]>([])

  const [loading, setLoadingConfig] = useState(true)
  const [_error, setError] = useState(false)
  const toast = useToast()

  const onChange = (id: number, wanted: number | string) => {
    const config = rows.filter((x: any) => x.id === Number(id))
    config[0].margem = Number(wanted)
    let configs = [...rows]
    const idData = configs.findIndex((x: any) => x.id === Number(id))
    configs = [...configs]
    configs[idData] = config[0]
    const newData = configs
    updateRows(newData)
    const obj = {
      id: id,
      margem: wanted
    }
    updateDataMargeUpdate([...rowsUpdate, obj])
  }
  const getData = useCallback(async () => {
    setLoadingConfig(true)
    setError(false)

    try {
      const {
        data: { data: res }
      } = await budget.getConfigMarge()
      updateRows(res)
    } catch (ex) {
      setError(true)
    }

    setLoadingConfig(false)
  }, [updateRows, setLoadingConfig])

  const saveUpdateMarge = useCallback(async () => {
    setLoadingConfig(true)
    const uniqueDataMarge = rowsUpdate.filter(
      (val, id, array) => array.indexOf(val) === id
    )
    budget
      .putConfigMarge({ configuracaoMargemMedia: uniqueDataMarge })
      .then(({ data: { _data } }) => {
        setLoadingConfig(false)
        toast({
          title: 'Sucesso.',
          description: 'Salvo configuracoes do calculo margem media',
          status: 'success',
          duration: 2000,
          isClosable: true
        })
      })
      .catch(() => {
        setLoadingConfig(false)
      })
  }, [setLoadingConfig, rowsUpdate, toast])

  useEffect(() => {
    if (isOpen) {
      getData()
    }
  }, [getData, isOpen])

  return (
    <>
      <Flex
        justifyContent="space-between"
        alignItems="left"
        paddingRight={4}
        paddingLeft={3}
        paddingY={2}
      >
        <Spacer />
        <Button
          fontSize={14}
          size="sm"
          color="#2F855A"
          borderRadius={5}
          border="1px solid #2F855A"
          cursor="pointer"
          transition="all ease .2s"
          _hover={{
            background: '#9AE6B4',
            color: '#1b4f35'
          }}
          onClick={onOpen}
        >
          Configurar
        </Button>
      </Flex>
      <Modal isOpen={isOpen} onClose={onClose} size="3xl" isCentered>
        <ModalOverlay />
        <ModalContent background={'white'} marginX={[4, 8, 16]}>
          <ModalHeader
            paddingTop={2}
            paddingBottom={2}
            paddingLeft={4}
            paddingRight={4}
            textColor={'gray.200'}
            background={'#1d5840'}
            borderTopLeftRadius={5}
            borderTopRightRadius={5}
            borderBottom="3px solid #ECC94B"
          >
            <Flex>
              <Box p={2}>
                <BiSliderAlt />
              </Box>
              <Box p={2} pt={1} w={1200}>
                Configuracao da Margem
              </Box>
            </Flex>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody bg="white" pt={0} py={4}>
            {loading ? (
              <Flex
                h="220px"
                flexDir="column"
                alignItems="center"
                justifyContent="center"
              >
                <Spinner size="lg" color="yellow.400" mb={4} />
                <Text maxW="420px" textAlign="center">
                  Obtendo Configuracoes... aguarde!
                </Text>
              </Flex>
            ) : (
              <>
                <TableContainer>
                  <Box h={200} maxW="100%" overflow="auto">
                    <Table colorScheme="teal">
                      <TableCaption>
                        Imperial to metric conversion factors
                      </TableCaption>
                      <Thead>
                        <Tr>
                          <Th>Id</Th>
                          <Th>Empresa</Th>
                          <Th>Margem</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {rows.map((row: any) => (
                          <Tr>
                            <Th>{row.empresa.codigo}</Th>
                            <Th>{row.empresa.descricao}</Th>
                            <Th>
                              <RadioGroup value={row.margem}>
                                <Stack spacing={5} direction="row">
                                  <Radio
                                    onClick={() => {
                                      onChange(row.id, 1)
                                    }}
                                    colorScheme="green"
                                    value={1}
                                  >
                                    3M
                                  </Radio>
                                  <Radio
                                    onClick={() => {
                                      onChange(row.id, 2)
                                    }}
                                    colorScheme="green"
                                    value={2}
                                  >
                                    6M
                                  </Radio>
                                  <Radio
                                    onClick={() => {
                                      onChange(row.id, 3)
                                    }}
                                    colorScheme="green"
                                    value={3}
                                  >
                                    12M
                                  </Radio>
                                </Stack>
                              </RadioGroup>
                            </Th>
                          </Tr>
                        ))}
                      </Tbody>
                    </Table>
                  </Box>
                </TableContainer>
              </>
            )}
          </ModalBody>
          <ModalFooter bg="white">
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Fechar
            </Button>
            <Button
              bg="green.600"
              color="#fff"
              onClick={() => {
                saveUpdateMarge()
                onClose()
              }}
              _hover={{
                bg: 'green.500'
              }}
              _active={{
                bg: 'green.500'
              }}
            >
              Salvar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

export default BudgetParameterModalConfig
